import React from "react"
import { withRouter } from "react-router"
import { useConfigurationContext } from "contexts/configuration/context"
import PolicyDetailsV2, { PolicyDetailsProps } from "./index.v2"
import { PolicyDetailsV3 } from "./index.v3"

const PolicyDetails: React.FunctionComponent<PolicyDetailsProps> = (props) => {
  const configuration = useConfigurationContext()
  switch (configuration.flags.platformVersion || "v2") {
    case "v2":
      return <PolicyDetailsV2 {...props} />
    case "v3":
      return <PolicyDetailsV3 {...props} configuration={configuration} />
  }
}

export default withRouter(PolicyDetails)
